module.exports = __webpack_public_path__ + "static/media/logo-text-112x61.419542b6.svg";